/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Cash } from './Cash';
import {
    instanceOfCash,
    CashFromJSON,
    CashFromJSONTyped,
    CashToJSON,
} from './Cash';
import type { FavritGiftCard } from './FavritGiftCard';
import {
    instanceOfFavritGiftCard,
    FavritGiftCardFromJSON,
    FavritGiftCardFromJSONTyped,
    FavritGiftCardToJSON,
} from './FavritGiftCard';
import type { Invoice } from './Invoice';
import {
    instanceOfInvoice,
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
} from './Invoice';
import type { MobileCardTerminal } from './MobileCardTerminal';
import {
    instanceOfMobileCardTerminal,
    MobileCardTerminalFromJSON,
    MobileCardTerminalFromJSONTyped,
    MobileCardTerminalToJSON,
} from './MobileCardTerminal';

/**
 * @type InitiateUnintegratedPaymentRequest
 * 
 * @export
 */
export type InitiateUnintegratedPaymentRequest = Cash | FavritGiftCard | Invoice | MobileCardTerminal;

export function InitiateUnintegratedPaymentRequestFromJSON(json: any): InitiateUnintegratedPaymentRequest {
    return InitiateUnintegratedPaymentRequestFromJSONTyped(json, false);
}

export function InitiateUnintegratedPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateUnintegratedPaymentRequest {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfCash(json)) {
        return CashFromJSONTyped(json, true);
    }
    if (instanceOfFavritGiftCard(json)) {
        return FavritGiftCardFromJSONTyped(json, true);
    }
    if (instanceOfInvoice(json)) {
        return InvoiceFromJSONTyped(json, true);
    }
    if (instanceOfMobileCardTerminal(json)) {
        return MobileCardTerminalFromJSONTyped(json, true);
    }
    return {} as any;
}

export function InitiateUnintegratedPaymentRequestToJSON(json: any): any {
    return InitiateUnintegratedPaymentRequestToJSONTyped(json, false);
}

export function InitiateUnintegratedPaymentRequestToJSONTyped(value?: InitiateUnintegratedPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfCash(value)) {
        return CashToJSON(value as Cash);
    }
    if (instanceOfFavritGiftCard(value)) {
        return FavritGiftCardToJSON(value as FavritGiftCard);
    }
    if (instanceOfInvoice(value)) {
        return InvoiceToJSON(value as Invoice);
    }
    if (instanceOfMobileCardTerminal(value)) {
        return MobileCardTerminalToJSON(value as MobileCardTerminal);
    }
    return {};
}

